import {useState} from "react";

import {deleteDoc, updateDoc} from "firebase/firestore";
import {Button, Col, Modal, Row, Spinner} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faSave} from "@fortawesome/free-solid-svg-icons";
import {RREmployeeType} from "../../types/RREmployeeType";
import {useAppSelector} from "../../hooks";
import {selectUsers} from "../../../features/AppAuthSlice";
import {showErrorsListInToast} from "../../tools";

export interface Props {
    doc: RREmployeeType;
    onDone: () => any;
}

export function EmployeeDelete({doc, onDone}: Props) {
    const [deleting, setDeleting] = useState(false);
    const users = useAppSelector(selectUsers);

    const deleteDimens = async () => {
        try {
            setDeleting(true);
            const user = users.find(
                u => u.employeeId === doc.id
            );

            if(user) {
                await  deleteDoc(user.ref!);
            }

            await updateDoc(doc.ref!, {isDeleted: true});
            setDeleting(false);
            onDone();
        } catch (e: any) {
            showErrorsListInToast("Грешка", [e.message]);
        } finally {
            setDeleting(false);
        }
    }

    return (
        <>
            <Modal.Body>
                <h5 className={"mb-3"}>
                    Изтриване на служител
                </h5>

                <div className={"text-danger"}>
                    Моля, потвърдете изтриването на служител <strong className={"text-primary"}>{doc.name}</strong>!
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Row className={"w-100"}>
                    {
                        deleting && <Col xs={12} className={"text-center"}>
                            <Spinner animation={"border"}/>
                        </Col>
                    }

                    {
                        !deleting &&
                        <>
                            <Col xs={6}>
                                <Button variant={"outline-secondary"} onClick={() => {
                                    onDone()
                                }}>
                                    <FontAwesomeIcon icon={faArrowLeft}/> Към списъка
                                </Button>
                            </Col>
                            <Col xs={6} className={"text-end"}>
                                <Button onClick={() => deleteDimens()} variant={"danger"}>
                                    <FontAwesomeIcon icon={faSave}/> Изтрий
                                </Button>
                            </Col>
                        </>
                    }
                </Row>
            </Modal.Footer>
        </>
    )
}
